module.exports = __webpack_public_path__ + "img/ic-po.70758655.svg";